import './css/estadisticaAsistencia.css';

function EstadisticaAsistencia({ asistencia = [], asistenciaGeneral = [], fechaSeleccionada, id_usuario }) {
    // Asistencia General diaria (Preceptor, id_curso=0)
    const genPresentes = asistenciaGeneral.filter((a) => a.fecha === fechaSeleccionada && a.asistencia === 'Presente').length;
    const genAusentes = asistenciaGeneral.filter((a) => a.fecha === fechaSeleccionada && a.asistencia === 'Ausente').length;
    const genTardes = asistenciaGeneral.filter((a) => a.fecha === fechaSeleccionada && a.asistencia === 'Tarde').length;
    const genRetiros = asistenciaGeneral.filter((a) => a.fecha === fechaSeleccionada && a.asistencia === 'Retiro').length;
    const genTotalPresentes = genPresentes + genTardes;
    const genTotalEst = genTotalPresentes + genAusentes;

    // Asistencia de la Materia (Docente)
    const cursoPresentes = asistencia.filter((a) => a.fecha === fechaSeleccionada && a.asistencia === 'Presente').length;
    const cursoAusentes = asistencia.filter((a) => a.fecha === fechaSeleccionada && a.asistencia === 'Ausente').length;
    const cursoTardes = asistencia.filter((a) => a.fecha === fechaSeleccionada && a.asistencia === 'Tarde').length;
    const cursoRetiros = asistencia.filter((a) => a.fecha === fechaSeleccionada && a.asistencia === 'Retiro').length;
    const cursoTotalPresentes = cursoPresentes + cursoTardes;
    const cursoTotalEst = cursoTotalPresentes + cursoAusentes;

    const hayDatosGeneral = asistenciaGeneral.some((a) => a.fecha === fechaSeleccionada);
    const hayDatosCurso = asistencia.some((a) => a.fecha === fechaSeleccionada);

    // Si hay asistencia general cargada, se usa como principal. De lo contrario, la de la materia.
    const pPresentes = hayDatosGeneral ? genTotalPresentes : cursoTotalPresentes;
    const pAusentes = hayDatosGeneral ? genAusentes : cursoAusentes;
    const pTardes = hayDatosGeneral ? genTardes : cursoTardes;
    const pRetiros = hayDatosGeneral ? genRetiros : cursoRetiros;
    const pTotalEst = hayDatosGeneral ? genTotalEst : cursoTotalEst;
    const pPorcentaje = pTotalEst > 0 ? Math.round((pPresentes / pTotalEst) * 100) : 0;

    const cPorcentaje = cursoTotalEst > 0 ? Math.round((cursoTotalPresentes / cursoTotalEst) * 100) : 0;

    return (
        <>
            {!id_usuario ? (
                <div className='row g-1 align-items-stretch'>
                    <div className="col-6 col-md-3 text-center">
                        <div className='cuadro-asistencia colorPresente py-2 px-1 h-100 d-flex flex-column justify-content-center'>
                            <h6 className="mb-1 fw-bold" style={{ fontSize: '0.85rem' }}>Presentes (Escuela)</h6>
                            <h3 className="mb-0 fw-bold">{pPresentes}</h3>
                            {hayDatosGeneral && hayDatosCurso && (
                                <span className="mt-1 badge border shadow-sm fw-bold" style={{ backgroundColor: '#75b798', color: '#ffffff', fontSize: '0.75rem' }}>
                                    Materia: {cursoTotalPresentes}
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="col-6 col-md-3 text-center">
                        <div className='cuadro-asistencia colorAusente py-2 px-1 h-100 d-flex flex-column justify-content-center'>
                            <h6 className="mb-1 fw-bold" style={{ fontSize: '0.85rem' }}>Ausentes (Escuela)</h6>
                            <h3 className="mb-0 fw-bold">{pAusentes}</h3>
                            {hayDatosGeneral && hayDatosCurso && (
                                <span className="mt-1 badge border shadow-sm fw-bold" style={{ backgroundColor: '#f87171', color: '#ffffff', fontSize: '0.75rem' }}>
                                    Materia: {cursoAusentes}
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="col-4 col-md-2 text-center">
                        <div className='cuadro-asistencia colorTarde py-2 px-1 h-100 d-flex flex-column justify-content-center'>
                            <h6 className="mb-1 fw-bold" style={{ fontSize: '0.85rem' }}>Tarde (Escuela)</h6>
                            <h3 className="mb-0 fw-bold">{pTardes}</h3>
                            {hayDatosGeneral && hayDatosCurso && (
                                <span className="mt-1 badge border shadow-sm fw-bold" style={{ backgroundColor: '#fde047', color: '#000000', fontSize: '0.75rem' }}>
                                    Materia: {cursoTardes}
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="col-4 col-md-2 text-center">
                        <div className='cuadro-asistencia py-2 px-1 h-100 d-flex flex-column justify-content-center' style={{ backgroundColor: '#fff3cd', borderColor: '#ffc107' }}>
                            <h6 className="mb-1 fw-bold text-dark" style={{ fontSize: '0.85rem' }}>Retiros (Escuela)</h6>
                            <h3 className="mb-0 fw-bold text-dark">{pRetiros}</h3>
                            {hayDatosGeneral && hayDatosCurso && (
                                <span className="mt-1 badge border shadow-sm fw-bold" style={{ backgroundColor: '#fd7e14', color: '#ffffff', fontSize: '0.75rem' }}>
                                    Materia: {cursoRetiros}
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="col-4 col-md-2 text-center">
                        <div className='cuadro-asistencia color3 py-2 px-1 h-100 d-flex flex-column justify-content-center'>
                            <h6 className="mb-1 fw-bold" style={{ fontSize: '0.85rem' }}>% Presentes (Escuela)</h6>
                            <h3 className="mb-0 fw-bold">{pPorcentaje}%</h3>
                            {hayDatosGeneral && hayDatosCurso && (
                                <span className="mt-1 badge border shadow-sm fw-bold" style={{ backgroundColor: '#60a5fa', color: '#ffffff', fontSize: '0.75rem' }}>
                                    Materia: {cPorcentaje}%
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            ) : ''}
        </>
    );
}

export default EstadisticaAsistencia;